import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store/store';

//引入wx
// 使用this.$wechat 或 this.$vux.wechat 或 this.$vux.$wechat
import WechatPlugin from 'vux/src/plugins/wechat/index.js';
Vue.use(WechatPlugin);

// import VConsole from 'vconsole';
// const vConsole = new VConsole();
// Vue.use(vConsole);

import _ from 'lodash';
import moment from 'moment';
Vue.prototype._ = _;
Vue.prototype.$moment = moment;

//Loading, toast, confirm
import LoadingPlugin from 'vux/src/plugins/loading/index.js';
import ToastPlugin from 'vux/src/plugins/toast/index.js';
import ConfigPlugin from 'vux/src/plugins/confirm/index.js';
Vue.use(ToastPlugin, {
    "type": "text",
    "width": "58.667vw", //220px
    "position": "middle",
    "isShowMask": true,
    "time": 2000,
});
Vue.use(ConfigPlugin);
Vue.use(LoadingPlugin);

//全局错误码
import ErrorCodePlugin from './common/config/index.js';
Vue.use(ErrorCodePlugin);

import './assets/css/base.scss';//引入全局初始化样式文件
import './assets/css/vux-edit.scss';//引入全局VUX样式修改文件

//symbol图标
import SfeIcon from './common/components/SfeIcon.vue';
Vue.component('sfe-icon', SfeIcon);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
